const CONFIG = {
    API_URL: 'https://trending-in-naija.uc.r.appspot.com',
    USER_LOGIN: 'login_user_easy_alert'
};
module.exports = CONFIG ;
